import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { BRAND } from "~/brand";
import { AuthForm } from "~/components/AuthForm";
import { sanitizeInternalPath } from "~/lib/safe-redirect";

export const Route = createFileRoute("/(auth-pages)/inloggen")({
  // Where to land after the OTP: set by the authenticated guard and by the
  // signing page's fallback. Validated again where it is used.
  validateSearch: z.object({ redirect: z.string().optional() }),
  component: LoginRoute,
});

function LoginRoute() {
  const { redirect } = Route.useSearch();

  return (
    <AuthForm
      title={`Login bij ${BRAND.name}`}
      submitLabel="Stuur login code"
      otpType="sign-in"
      fromRoute="/inloggen"
      flow="sign-in"
      redirectTo={sanitizeInternalPath(redirect) ?? undefined}
    />
  );
}
